import { useEffect } from 'react';
import { useAppDispatch } from '../../../store/store';
import { getUsers } from '../../../store/reducers/UsersSlice';
import { getClinics } from '../../../store/reducers/ClinicSlice';
import { useDebounce } from '../../shared/useDebounce';
import { useUsersColumns } from './useUsersColumns/useUsersColumns';
import { useUsersHandlers } from './useUsersHandlers/useUsersHandlers';
import { useUsersState } from './useUsersState/useUsersState';
import { useFilterOption } from '../../shared/useFilterOption';
import { getRoles } from '../../../store/reducers/RoleSlice';

export const useUsers = () => {
  const {
    clinics,
    roles,
    totalCount,
    pageSize,
    setPageSize,
    callRequest,
    setCallRequest,
    total,
    currentUsers,
    allUsers,
    status,
  } = useUsersState();

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getClinics());
    dispatch(getRoles());
  }, []);

  const debouncedCallRequest = useDebounce(callRequest, 500);

  useEffect(() => {
    dispatch(getUsers(debouncedCallRequest));
  }, [debouncedCallRequest]);

  useEffect(() => {
    const maxPageIndex = Math.floor(total / callRequest.PageSize);
    if (maxPageIndex < callRequest.PageIndex && callRequest.PageIndex !== 0) {
      setCallRequest((prev) => ({
        ...prev,
        PageIndex: maxPageIndex,
      }));
    }
  }, [total, callRequest.PageSize, callRequest.PageIndex]);

  const { COLUMNS, onTableChange } = useUsersColumns({
    onCallRequest: setCallRequest,
    callRequest,
    clinics,
  });

  const divider = {
    height: 1,
    backgroundColor: '#daccccff',
    margin: '12px 0 20px 0',
  };

  const {
    handleSearch,
    handleChange,
    handlePageSizeChange,
    handleClinicsChange,
    clinicValue,
    handleOpenClinics,
    handleRoleChange,
    roleValue,
    handleOpenRoles,
    handleIsLockoutChange,
    isLockoutValue,
    handleOpenIsLockout,
  } = useUsersHandlers({
    onCallRequest: setCallRequest,
    callRequest,
    onPageSize: setPageSize,
    total,
  });

  const filterOption = useFilterOption();

  return {
    setCallRequest,
    callRequest,
    clinics,
    roles,
    isLoading: status.responseLoading,
    hasLoadError: status.responseError !== null,
    pageSize,
    totalCount,
    total,
    handleChange,
    currentUsers,
    handleSearch,
    allUsers,
    COLUMNS,
    onTableChange,
    divider,
    handlePageSizeChange,
    filterOption,
    handleClinicsChange,
    clinicValue,
    handleOpenClinics,
    handleRoleChange,
    roleValue,
    handleOpenRoles,
    handleIsLockoutChange,
    isLockoutValue,
    handleOpenIsLockout,
  };
};
